import { axiosInstance } from '~/common/utils/api.util';

import type { ApiResponse } from '~/common/types/api.type';
import type {
  RemotePcAgentUsageStatistics,
  UsageStatisticsParams,
} from '~/features/remote-pc-agent/types/remote-pc-agent.type';

/**
 * 스토어 IP 사용량 통계 조회
 * @description ADMIN, STORE_MANAGER 권한 필요 - 스토어 IP별 사용량 통계를 조회합니다
 * @endpoint GET /admin/remote-pc-agents/usage-statistics
 * @param params - 조회 파라미터 (storeId, startDate, endDate)
 * @returns 사용량 통계
 */
export function getRemotePcAgentUsageStatisticsApi(params?: UsageStatisticsParams) {
  return axiosInstance.get<ApiResponse<RemotePcAgentUsageStatistics>>(
    '/admin/remote-pc-agents/usage-statistics',
    { params },
  );
}
